<template>
  <b-overlay :show="apiRslt.fetch.inProgress" rounded="sm" opacity="0.5" blur="none">
    <div class="row">
        <div class="col-md-6">
          <text-field
              name="Nom"
              property="name"
              v-model="$v.form.name.$model"
              :error="$v.form.name.$error"
              :isRequired="checkIfRequired($v.form.name)"
              errorCode="MESS001"
          />
        </div>
        <div class="col-md-6">
          <text-field
              name="Dénomination"
              property="denomination"
              v-model="$v.form.denomination.$model"
              :error="$v.form.denomination.$error"
              :isRequired="checkIfRequired($v.form.denomination)"
              errorCode="MESS001"
          />
        </div>
        <div class="col-md-12">
          <p class="text-muted small"> <sup>*</sup> Ne doit pas contenenir que des lettres et des chiffres sans séparation</p>
        </div>
        <div class="col-md-6">
          <text-field
              name="Téléphone"
              property="tel"
              v-model="$v.form.tel.$model"
              :error="$v.form.tel.$error"
              :isRequired="checkIfRequired($v.form.tel)"
              errorCode="MESS010"
          />
        </div>
        <div class="col-md-6">
          <text-field
              name="Email"
              property="email"
              v-model="$v.form.email.$model"
              :error="$v.form.email.$error"
              :isRequired="checkIfRequired($v.form.email)"
              errorCode="MESS009"
          />
        </div>
        <div class="col-md-8">
          <textarea-field
              name="Horaires"
              property="opening"
              v-model="$v.form.opening.$model"
              :error="$v.form.opening.$error"
              :isRequired="checkIfRequired($v.form.opening)"
              errorCode="MESS001"
          />
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12">
                <small class="text-muted">Horaires d'ouverture<span v-if="checkIfRequired($v.form.openingTime)">*</span></small>
            </div>
            <div class="col-md-12">
              <b-button id="select-opening" v-b-modal.modal-center block :class="{'btn-success': !$v.form.openingTime.$error, 'btn-danger': $v.form.openingTime.$error }" @click="checkIfOpeningExist">
                Sélectionner
              </b-button>
            </div>
            <div class="col-md-12">
              <small class="text-danger" v-if="$v.form.openingTime.$error">Veuillez renseigner la plage horaire</small>
            </div>
          </div>
        </div>
        <b-modal id="modal-center" class="avant"  size="lg" centered title="Sélectionner les horaires d'ouverture">
          <div class="row d-flex justify-content-arround" v-for="(item,index) in $v.form.openingTime.$each.$iter" :key="index">
            <div class="col-md-2 text-right my-auto">
              <h1 class="text-capitalize is-size-5">{{ item.day.$model }}</h1>
              <p class="small">
                Actuellement <br>
                <span class="text-success" v-if="isOpen(item.day.$model)">ouvert</span>
                <span class="text-danger" v-else>fermé</span>
              </p>
            </div>

            <div class="col-md-4 offset-md-1">
              <div class="form-floating">
                <input :id="`startOpening-${index}`" class="form-control" v-model="item.startOpening.$model" type="time" :class="{'is-invalid': $v.form.openingTime.$each.$iter[index].startOpening.$error }"/>
                <label >Ouverture</label>
              </div>
              <message-error code="MESS001" :hasError="$v.form.openingTime.$each.$iter[index].startOpening.$error"/>
            </div>
            
            <div class="col-md-4 offset-md-1">
              <div class="form-floating">
                <input 
                  :id="`endOpening-${index}`"
                  class="form-control" 
                  v-model="item.endOpening.$model"
                  type="time" 
                  :class="{'is-invalid': $v.form.openingTime.$each.$iter[index].endOpening.$error }"
                  />
                <label >Fermeture</label>
              </div>
              <message-error code="MESS001" :hasError="$v.form.openingTime.$each.$iter[index].endOpening.$error"/>
            </div>
          </div>
          <template #modal-footer="{ cancel }">
            <div class="w-100">
              <b-button
                id="btn-submit-opening"
                variant="primary"
                size="sm"
                class="float-right"
                @click="submitOpening()"
              >
                Valider
              </b-button>
              <b-button
                variant="secondary"
                size="sm"
                class="float-left"
                @click="cancel()"
              >
                Close
              </b-button>
            </div>
          </template>
        </b-modal>
        
        <div class="col-md-6">
          <text-field
              name="Addresse"
              property="adresse"
              v-model="$v.form.adresse.$model"
              :error="$v.form.adresse.$error"
              :isRequired="checkIfRequired($v.form.adresse)"
              errorCode="MESS001"
          />
        </div>
        <div class="col-md-6">
          <text-field
              name="Ville"
              property="city"
              v-model="$v.form.city.$model"
              :error="$v.form.city.$error"
              :isRequired="checkIfRequired($v.form.city)"
              errorCode="MESS001"
          />
        </div>
        <div class="col-md-12">
          <textarea-field
              name="Précision adresse"
              property="description"
              v-model="$v.form.description.$model"
              :error="$v.form.description.$error"
              :isRequired="checkIfRequired($v.form.description)"
              errorCode="MESS007"
          />
        </div>
        <div class="col-md-12">
          <small class="text-secondary"> Est-il ouvert au public ? <span class="text-danger" v-if="checkIfRequired($v.form.isActive)">*</span> </small>
        </div>
        <div class="col-md-12 ml-4">
            <div class="form-check form-switch">
              <input 
                v-model="$v.form.isActive.$model"
                class="form-check-input" 
                type="checkbox" 
                id="isActive"
              >
              <label class="form-check-label" for="flexSwitchCheckDefault">Activation point de vente</label>
            </div>
        </div>
        <div class="col-md-12 mt-3">
          <div class="row">
            <div class="col-md-3">
              <text-field
                name="longitude"
                property="longitude"
                v-model="$v.form.longitude.$model"
                :error="$v.form.longitude.$error"
                :isRequired="checkIfRequired($v.form.longitude)"
                errorCode="MESS001"
              />
            </div>
            <div class="col-md-3">
              <text-field
                name="latitude"
                property="latitude"
                v-model="$v.form.latitude.$model"
                :error="$v.form.latitude.$error"
                :isRequired="checkIfRequired($v.form.latitude)"
                errorCode="MESS001"
              />
            </div>
            <div class="col-md-6">
              <select-field
                v-model="$v.form.image.$model"
                property="image"
                name="image"
                :options="imageSelect"
                :error="$v.form.image.$error"
                :isRequired="checkIfRequired($v.form.image)"
                errorCode="MESS004"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-4">
          <button id="btn-crud-add" class="btn btn-primary float-right" v-show="operation==='add'" style="border-radius: 0;" @click="added">Ajouter</button>
          <button id="btn-crud-update" class="btn btn-primary float-right" v-show="operation==='update'" style="border-radius: 0;" @click="updated">Modifier</button>
          <button id="btn-crud-remove" class="btn float-left bg-danger text-white" v-show="operation==='update'" style="border-radius: 0;" @click="deleted">Supprimer</button>
        </div>
      </div>
  </b-overlay>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {mapActions, mapState} from "vuex"
import form from "@/core/mixins/form"
import {TextField, TextareaField, SelectField } from "@/core/components/form";
import moment from "moment";


moment.locale('fr');

export default {
  name: 'FormOutlet',
  components: { TextField, TextareaField, SelectField },
  mixins:[form],
  computed:{
    ...mapState('outlets', ['apiRslt']),
  },
  data() {
    return {
      form: {
        name: "",
        adresse: "",
        denomination:"",
        city:"",
        tel: "",
        isActive: false,
        description: "",
        email:"",
        opening:"",
        image:"",
        longitude:"",
        latitude:"",
        openingTime:[
          { day: 'lundi',  startOpening: '', endOpening: '' },
          { day: 'mardi',  startOpening: '', endOpening: '' },
          { day: 'mercredi',  startOpening: '', endOpening: '' },
          { day: 'jeudi',  startOpening: '', endOpening: '' },
          { day: 'vendredi',  startOpening: '', endOpening: '' },
          { day: 'samedi',  startOpening: '', endOpening: '' },
          { day: 'dimanche',  startOpening: '', endOpening: '' }
        ]
      },
      init: {
        name: "",
        adresse: "",
        denomination:"",
        city:"",
        tel: "",
        isActive: false,
        description: "",
        email:"",
        opening:"",
        image:"",
        longitude:"",
        latitude:"",
        openingTime:[
          { day: 'lundi',  startOpening: '', endOpening: '' },
          { day: 'mardi',  startOpening: '', endOpening: '' },
          { day: 'mercredi',  startOpening: '', endOpening: '' },
          { day: 'jeudi',  startOpening: '', endOpening: '' },
          { day: 'vendredi',  startOpening: '', endOpening: '' },
          { day: 'samedi',  startOpening: '', endOpening: '' },
          { day: 'dimanche',  startOpening: '', endOpening: '' }
        ]
      },
      imageSelect:[
        {text:'Étiquette Kiosque', value: 'etiquettes_kiosque.png'},
        {text:'Étiquette Roulotte', value: 'etiquettes_roulotte.png'},
      ]
    }
  },

  methods: {
    ...mapActions('outlets', ['addOutlet','updateOutlet', 'deleteOutlet']),
    address(event){
      this.form.city = event.city
      this.form.denomination = event.denomination.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replaceAll('-','').toLowerCase()
    },
    added(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error) this.addOutlet(this.form)
    },
    updated(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error) this.updateOutlet(this.form)
    },
    deleted(){
      this.deleteOutlet(this.form.id)
      this.reset(this.form.id)
    },
    submitOpening(){
      this.$v.form.openingTime.$touch()
      if(!this.$v.form.openingTime.$error){
        this.$bvModal.hide('modal-center')
      }
    },
    isOpen(day){
      // day + form.openingTime
      let currentDay = this.form.openingTime.find(x => x.day === day)
      
      if(day === moment().format('dddd')){
        let time = moment()
        let start = moment(currentDay.startOpening,'HH:mm')
        let end = moment(currentDay.endOpening,'HH:mm')
        return time.isBetween(start,end)
      }else {
        return false
      }
    },
    moment: function () {
      return moment();
    },
    checkIfOpeningExist(){
      if(this.form.openingTime.length <= 0 || !this.form.openingTime){
        this.form.openingTime = this.init.openingTime
      }
    }
  },
  validations() {
    return {
        form:{
          name: {required},
          denomination:{ required},
          city: {},
          adresse: {required},
          tel: {required},
          isActive: { required },
          description: {},
          email: { required },
          opening: { required },
          image: { required },
          longitude: {required },
          latitude: {required},
          openingTime: {
            required,
            $each: {
              day: { required },
              startOpening:{ required },
              endOpening:{ required }
            }
          }  
        }
    }
  },
}
</script>

<style>
h1.is-size-5 {
  font-size: 1rem;
}
.btn {
  border-radius: 0;
}

</style>
